import c from 'classnames';
import React from 'react';
import { CustomIcon, FeatureIcon, SubduedIcon } from '../types/pricingPage';
import { iconToUrl } from '../utils/features';

interface Props {
    featureIcon: FeatureIcon | SubduedIcon | CustomIcon;
    baseUrl?: string;
}
export default function FeatureIconImage({ featureIcon, baseUrl = '' }: Props) {
    const isRounded = featureIcon === FeatureIcon.CIRCLE || featureIcon === FeatureIcon.GREEN;
    return (
        <img
            src={iconToUrl(featureIcon, baseUrl)}
            alt=""
            className={c('inline-block w-5 h-5 p-0 mr-2 align-middle', { 'bg-white rounded-full': isRounded })}
            width={10}
        />
    );
}
